module.exports = __webpack_public_path__ + "static/img/QF.b866892d.png";